import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store/store';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import BoostrapVue from 'bootstrap-vue';
import VueCookies from 'vue-cookies';
import '@/components/_globals.ts';
import web from '@/web';
import consts from '@/consts.ts';
import constants from '@/constants.js';
import utils from '@/utils';
import storage from '@/storage.js';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

Vue.prototype.$api_service = ApiService;
Vue.prototype.$jwt_service = JwtService;
Vue.prototype.$web = web
Vue.prototype.$consts = consts;
Vue.prototype.$constants = constants;
Vue.prototype.$utils = utils;
Vue.prototype.$storage = storage;

Vue.use(BoostrapVue);
Vue.use(VueCookies)

ApiService.init();

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
